import { Injectable } from '@angular/core';
import { UberFilterDataService } from './uber-filter-data.service';
import { UberFilterConfig } from './uber-filter-config';
import { MultiCheckboxConfig } from '../multi-check-box/multi-checkbox-config';

@Injectable()
export class UberFilterService {


  constructor() { }

  getFilterMappings(data: any[], filters: UberFilterConfig[]): Object {
    // let recursiveBuild = function (data: any[], filters: UberFilterConfig[], currFilter: UberFilterConfig) {
    //   let lowers = filters.filter(filter => filter.level === currFilter.level + 1);
    //   if (0 === lowers.length) {
    //     let res2 = {};
    //     unique(data.map(itr => itr[currFilter.filterConfig.key]))
    //       .forEach(it => res2[it] = data.filter(datum => datum[currFilter.filterConfig.key] === it).length);
    //     return res2;
    //   } else {
    //     let values: string[] = unique(data.map(itr => itr[currFilter.filterConfig.key]));
    //     let resp = {};
    //     values.forEach(fil => {
    //       let filteredData = data.filter(datum => datum[currFilter.filterConfig.key] === fil);
    //       let res = {};
    //       lowers.forEach(lower => res[lower.filterConfig.key] = recursiveBuild(filteredData, filters, lower));
    //       resp[fil] = res;
    //     })
    //     return resp;
    //   }
    // }
    // let highLvl = filters.filter(it => it.type === 'checkbox').sort((a, b) => a.affects - b.affects);
    let response = {};
    // highLvl.filter(it => it.affects === highLvl[0].affects).forEach(category => {
    //   response[category.filterConfig.key] = recursiveBuild(data, filters, category);
    // });
    return response;
  }

  /*
   * @return: list of filters
   * Each filter is the union of all values or null if a higher level filter has no such values
  */
  getFilters(mapping: Object, filterConfigs: UberFilterConfig[]): any {
    // for(let filterConfig of filterConfigs.filter(it => it.type === 'checkbox').sort((a, b) => a.affects - b.affects)) {
    //   // if
    // }
  }
}

function unique(src: any[]) {
  let arr = [];
  for (let input of src) {
    if (!arr.includes(input)) {
      arr.push(input);
    }
  }
  return arr;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/uber-filter/uber-filter.service.ts